import React, { useEffect, useState } from 'react';
import { Route, Redirect, withRouter } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { userRole } from '../store/selectors/auth.selector';
import getItemFromLocalStorage from '../utils/getItemFromLocalStorage';
import {
  getStoredRefreshToken,
  handleLogout,
  isTokenExpired,
  refreshAccessToken,
} from '../helpers/tokenManager';
import AuthLoadingScreen from '../components/controls/spinner/AuthLoadingScreen';

const PrivateRoute = ({ component, path, url, routeRole }) => {
  const token = getItemFromLocalStorage('accessToken');
  const role = useSelector(userRole);

  // 'checking' means the access token is present but expired - we must not
  // render protected content (stale data) until we know whether the refresh
  // token can silently renew the session or the user needs to be logged out.
  const [status, setStatus] = useState(() => {
    if (!token) return 'unauthenticated';
    return isTokenExpired(token) ? 'checking' : 'authenticated';
  });

  useEffect(() => {
    if (status !== 'checking') return;

    if (!getStoredRefreshToken()) {
      handleLogout();
      return;
    }

    refreshAccessToken()
      .then(() => setStatus('authenticated'))
      .catch(() => handleLogout());
  }, [status]);

  if (status === 'unauthenticated') {
    return <Redirect to={{ pathname: '/' }} />;
  }

  if (status === 'checking') {
    return <AuthLoadingScreen />;
  }

  if (routeRole === 'Administrator' || routeRole.includes(role)) {
    return <Route exact path={path} component={withRouter(component)} />;
  }
  return <Redirect to={{ pathname: `/dashboard` }} />;
};

export default PrivateRoute;